import type { NeedsYourAttentionDTO } from "../models/needsYourAttentionDto";
import type { NeedsYourAttentionEntity } from "../../domain/entities/NeedsYourAttentionEntity";

export function needsYourAttentionDtoToEntity(
  dto: NeedsYourAttentionDTO,
): NeedsYourAttentionEntity {
  return {
    overdueInvoices: {
      totalOverdueAmount: Number(dto.overdueInvoices?.totalOverdueAmount) ?? 0,
      invoiceCount: Number(dto.overdueInvoices?.invoiceCount) ?? 0,
      customerCount: Number(dto.overdueInvoices?.customerCount) ?? 0,
      currencySymbol: dto.overdueInvoices?.currencySymbol ?? "₹",
    },
    overdueBills: {
      totalOverdueAmount: Number(dto.overdueBills?.totalOverdueAmount) ?? 0,
      billCount: Number(dto.overdueBills?.billCount) ?? 0,
      vendorCount: Number(dto.overdueBills?.vendorCount) ?? 0,
      currencySymbol: dto.overdueBills?.currencySymbol ?? "₹",
    },
    oldestOverdueCompliance: dto.oldestOverdueCompliance
      ? {
          complianceFormName: dto.oldestOverdueCompliance.complianceFormName,
          period: dto.oldestOverdueCompliance.period,
          dueDate: dto.oldestOverdueCompliance.dueDate,
          daysOverdue: Number(dto.oldestOverdueCompliance.daysOverdue) ?? 0,
          description: dto.oldestOverdueCompliance.description,
        }
      : null,
    queriesAssignedToMe: {
      count: Number(dto.queriesAssignedToMe?.count) ?? 0,
      oldestDays:
        dto.queriesAssignedToMe?.oldestDays != null
          ? Number(dto.queriesAssignedToMe.oldestDays)
          : null,
    },
    // uncategorizedBankTransactions: (dto.uncategorizedBankTransactions ?? []).map(
    //   (item) => ({
    //     bankName: item.bankName ?? "Unknown",
    //     count: Number(item.count) ?? 0,
    //   })
    // ),
  };
}
